// extracted by mini-css-extract-plugin
export default {"container":"relinking-module__container__ilOT7","relinkingWrapperMobile":"relinking-module__relinkingWrapperMobile__7OOXK"};